<template>
  <!-- MBR072 campaign reward claim sheet — member_app_UI/song_fa_members_my_challenges_mobile -->
  <div
    class="modal modal-bottom fade"
    id="campaign-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="campaign-modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-claim">
        <div class="mbr-claim__top">
          <span class="mbr-claim__handle" aria-hidden="true"></span>
          <!-- keep .btn-close: views close every open sheet with $(".btn-close").click() -->
          <button
            type="button"
            class="btn-close mbr-claim__close"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          >
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div class="mbr-claim__body">
          <section class="mbr-claim__card mbr-claim__reward">
            <img
              v-if="voucherDetail.icon_url"
              class="mbr-claim__thumb"
              :src="voucherDetail.icon_url"
              :alt="voucherDetail.reward_title ?? ''"
            />
            <div class="mbr-claim__reward-text">
              <h2 class="mbr-claim__title">{{ voucherDetail.reward_title ?? "" }}</h2>
              <span v-if="voucherDetail.expiry_date_text" class="mbr-claim__expiry">
                <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" /><path stroke-linecap="round" d="M12 6v6l4 2" /></svg>
                <span>{{ validityText(voucherDetail.expiry_date_text) }}</span>
              </span>
            </div>
          </section>

          <section v-if="hasApplicability" class="mbr-claim__card">
            <h3 class="mbr-claim__heading">{{ $t('challenges.applicable_for') }}</h3>
            <div class="mbr-claim__rows">
              <div v-if="voucherDetail.tier_can_exchange_text" class="mbr-claim__row">
                <span class="mbr-claim__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ voucherDetail.tier_can_exchange_text }}</p>
              </div>
              <div v-if="voucherDetail.branch_can_exchange_text" class="mbr-claim__row">
                <span class="mbr-claim__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ voucherDetail.branch_can_exchange_text }}</p>
              </div>
              <div v-if="voucherDetail.item_apply_text" class="mbr-claim__row">
                <span class="mbr-claim__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ voucherDetail.item_apply_text }}</p>
              </div>
              <div v-if="voucherDetail.order_minimum_text" class="mbr-claim__row">
                <span class="mbr-claim__icon" aria-hidden="true">
                  <svg fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                </span>
                <p>{{ voucherDetail.order_minimum_text }}</p>
              </div>
            </div>
          </section>

          <button
            type="button"
            class="mbr-claim__cta"
            @click="processExchange(voucherDetail.id)"
          >
            {{ $t('challenges.get') }}
          </button>
        </div>
      </div>
    </div>
    <button
      class="btn-campaign-modal"
      style="display: none"
      data-bs-toggle="modal"
      data-bs-target="#campaign-modal"
    >
      Success
    </button>
  </div>
</template>

<script>
import { validityText } from "@/i18n/apiText";

export default {
  name: "CampaignReward",
  components: {},
  props: {
    voucherDetail: {
      type: Object,
      default() {
        return {};
      },
    },
    processExchange: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    // the backend sends full sentences, one per rule; drop the card when none apply
    hasApplicability() {
      return Boolean(
        this.voucherDetail.tier_can_exchange_text ||
          this.voucherDetail.branch_can_exchange_text ||
          this.voucherDetail.item_apply_text ||
          this.voucherDetail.order_minimum_text
      );
    },
  },
  methods: {
    validityText,
  },
};
</script>
<style scoped>
/* MBR072 claim sheet — same shell as the voucher detail sheet (MBR035).
   Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-claim {
  max-height: 88vh;
  padding: 12px 20px 28px;
  overflow-y: auto;
  background: var(--mbr-color-canvas);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
}

/* custom.css still carries the legacy `* { font-family: Poppins }` */
.mbr-claim :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-claim__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-claim__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

/* reset Bootstrap's .btn-close (svg background, 1em box, 50% opacity) */
.mbr-claim__close.btn-close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint) none;
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  opacity: 1;
  transition: transform 0.12s ease;
}

.mbr-claim__close.btn-close:active {
  transform: scale(0.95);
}

.mbr-claim__close.btn-close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
  box-shadow: none;
}

.mbr-claim__close svg {
  width: 16px;
  height: 16px;
}

.mbr-claim__body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: stretch;
  padding-top: 4px;
}

.mbr-claim__card {
  padding: 18px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
}

.mbr-claim__reward {
  display: flex;
  align-items: center;
  gap: 14px;
}

.mbr-claim__thumb {
  flex: none;
  width: 88px;
  height: 88px;
  object-fit: cover;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-md);
}

.mbr-claim__reward-text {
  min-width: 0;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-claim__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 18px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: var(--mbr-color-ink-strong);
}

.mbr-claim__expiry {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 4px 12px;
  background: var(--mbr-color-tint-dark);
  border-radius: var(--mbr-radius-full);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-claim__expiry svg {
  flex: none;
  width: 14px;
  height: 14px;
  color: var(--mbr-color-primary);
}

.mbr-claim__heading {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: normal;
  color: var(--mbr-color-ink-headline);
}

.mbr-claim__rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 14px;
}

.mbr-claim__row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.mbr-claim__row p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-claim__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: var(--mbr-color-peach);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-positive);
}

.mbr-claim__icon svg {
  width: 14px;
  height: 14px;
}

.mbr-claim__cta {
  margin-top: 4px;
  padding: 16px;
  background: var(--mbr-color-primary);
  border: 0;
  border-radius: var(--mbr-radius-full);
  box-shadow: 0 2px 8px rgba(var(--mbr-color-primary-rgb), 0.16);
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--mbr-color-on-primary);
  transition: background 0.15s ease, transform 0.12s ease;
}

.mbr-claim__cta:hover {
  background: var(--mbr-color-primary-light);
}

.mbr-claim__cta:active {
  transform: scale(0.99);
}

/* Bottom-sheet positioning (only the rules this sheet uses) */
.modal.modal-bottom .modal-dialog {
  position: fixed;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: auto;
  transform: translate3d(0%, 0, 0);
}

.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
  border: none;
  border-radius: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}
</style>
